import { Brand, Program } from '..';

const AbritelPrograms: Record<string, Program> = {
  abritel: {
    id: 'abritel',
    name: 'Abritel FR',
    brand: Brand.ABRITEL,
    posa: 'FR',
    currency: 'EUR',
    locale: {
      baseName: 'fr_FR',
      langId: 1036,
    },
  },
};

export { AbritelPrograms };
